import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import { styleTheme } from '../../style/theme'

import { useConfig } from '../../routes'
import { Form } from './components/Form'
import { ReservationContainerProps, ReservationProps } from './Reservation.types'
import { Tab, TabItem } from '../../components/ui-parts/Tab'
import { RequiredIcon } from 'customer/icons/requiredMark'

type ConfigType = {
  primaryColor: string
  viewTitle?: string | null
  topMessage?: string | null
}

export enum ScheduleType {
  online = 'online',
  onsite = 'onsite',
}

export const Reservation: React.FC<ReservationContainerProps> = (props) => {
  const config = useConfig() as ConfigType
  return (
    <StyledPage
      {...props}
      primaryColor={config.primaryColor}
      viewTitle={config.viewTitle}
      topMessage={config.topMessage}
    />
  )
}

const Page: React.FC<ReservationProps> = ({ className, viewTitle, topMessage }) => {
  const config = useConfig() as ConfigType
  const primaryColor = config.primaryColor
  const searchParams = new URLSearchParams(window.location.search)
  const hiddenSelectParams = searchParams.get('hidden_select')
  const [selectType, setSelectType] = useState<ScheduleType>(searchParams.get('select_type') as ScheduleType)
  const { reservationPageKey } = useParams()

  return (
    <div className={className}>
      {viewTitle && <h3 className="title">{viewTitle}</h3>}
      {topMessage && <pre className="top-message">{topMessage}</pre>}
      <p className="description">
        <RequiredIcon />
        <span className="text">入力必須項目です</span>
      </p>
      {hiddenSelectParams !== 'true' && (
        <div className="tab">
          <Tab defaultKey={selectType} primaryColor={primaryColor} onChange={setSelectType}>
            <TabItem tabKey="onsite" title="来館相談予約"></TabItem>
            <TabItem tabKey="online" title="オンライン相談予約"></TabItem>
          </Tab>
        </div>
      )}
      <Form selectType={selectType} reservationPageKey={reservationPageKey || ''} />
    </div>
  )
}

const StyledPage = styled(Page)`
  max-width: 768px;
  margin: 0 auto;
  background-color: ${styleTheme.colors.white};
  color: ${styleTheme.colors.black};
  padding: 32px 16px;
  padding-bottom: 64px;
  margin-left: auto;
  margin-right: auto;

  > .title {
    text-align: center;
    color: ${(props) => props.primaryColor};
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 24px;
  }

  > .top-message {
    font-size: 14px;
    color: #585858;
    line-height: 1.8;
  }

  > .description {
    display: flex;
    gap: 4px;
    font-size: 14px;
    color: #585858;
    line-height: 1.5;
    margin-bottom: 24px;

    > .text {
      color: #ff5757;
    }
  }

  > .tab {
    margin-bottom: 30px;
  }
`
